const routes = {
  home: "/",
  dashboard: "/dashboard",
  users: "/users",
  userItem: "/users/:id",
  usersBusiness: "/users-business",
  profile: "/profile",
  profileTwoFA: "/profile/2fa",
  profile2fa: "/profile/2fa",
  profileChangePassword: "/profile/change-password",
  changePasswordProfile: "/profile/change-password",
  reset2FA: "/reset-2fa",
  emailHistory: "/email-history",
  smsHistory: "/sms-history",
  usersBusinessItem: "/users-business/:id",
  transactions: "/transactions",
  updatedtransactions: "/updated-transactions",

  exportsList: "/exports-list",
  transactionsBusiness: "/transactions-business",
  updatedtransactionsBusiness: "/updated-transactions-business",
  mtsTransferLogs: "/mts-logs",

  pendingWithdrawals: "/pending-withdrawals",
  pendingWithdrawalsBuisiness: "/pending-withdrawals-buisiness",
  pendingDeposit: "/pending-deposit",
  pendingDepositBuisiness: "/pending-deposit-buisiness",
  unidentifiedDeposits: "/unidentified-deposits",
  individualmanualTransfers: "/individual-manual-transfers",
  businessmanualTransfers: "/business-manual-transfers",

  feeManagement: "/fee",
  moneyMoverCategories: "money-mover-categories",
  moneyMoverServices: "money-mover-services",
  moneyMoverCasinoServices: "money-mover-casino-services",
  // feeMgt:"/fee-mgt",
  admins: "/admins",
  limitations: "/limitations",
  limitationsBusiness: "/limitations-business",
  limitationsMoneyMoversIndividual: "/limitations-money-movers-individual",
  limitationsMoneyMoversBusiness: "/limitations-money-movers-business",
  feeManagementBusiness: "/fee-business",
  notification: "/notification",
  adminAlerts: "/alerts",
  emailTemplate: "/email-template",

  currency: "/currency",
  bankAccounts: "bank-accounts",
  settings: "/settings",
  invoice: "/invoice",
  logout: "/logout",
  fastTransfer: "fast-money-transfer",
  ourPrices: "/our-prices",
  translation: "/translation",
  mobileTranslation: "/mobile-translation",
  backendTranslation: "/backend-translation",
  Conversion: "/conversion",
  provider: "self-terminal/provider",
  providerTransaction: "self-terminal/transactions",
  guestUserTransaction: "guest-user-transacions",
  guestUserFees: "guest-user-fee",
  adminActivity: "manage-activity",
  activityLogs: "activity-logs",
  walletTerminal: "wallet-terminal",
  serviceMaintenance: "service-maintenance",
  serviceAlerts: "service-alerts",
  serviceIncidents: "service-incidents",

  cardPackages: "/card-packages",
  cardPackageForm: "/card-packages/create",
  cardPackageEditForm: "/card-packages/edit/:id",

  cardProducts: "/card-products",
  cardProductForm: "/card-products/create",
  cardProductEditForm: "/card-products/edit/:id",

  cardTermsConditions: "/card-terms-conditions",
  cardTermsConditionsForm: "/card-terms-conditions/create",
  cardTermsConditionsEditForm: "/card-terms-conditions/edit/:id",

  cardMerchants: "/card-merchants",
  cardMerchantsView: "/card-merchants/:id",

  cardConversionList: "/card-conversions",
  cardConversionSyncHistory: "/card-conversion-sync-history",
  cardAllTransactions: "/card-transactions",
  orderedCards: "/ordered-cards",
  cardPool: "/card-pool",

  cardTypes: "/card-types",
  cardTypeForm: "/card-types/create",
  cardTypeEditForm: "/card-types/edit/:id",

  cardBillings: "/card-billings",
  kafkaNotifications: "/kafka-notifications",
  orderedCardHistory: "/ordered-virtual-cards",
  kafkaSyncHistory: "/kafka-sync-history",

  manageFaqs: "/manage-faqs",
  manageBlogs: "manage-blogs",
  roles: "/manage-roles-permission",
  permissions: "/permissions",
  channelPartners: "/manage-channel-partners",
  adminManageWhiteLabel: "/admin-manage-white-label",
  adminManageWhiteLabelItem: "/admin-manage-white-label/:id",
  // globalMaintenance: "global-maintenance",
};
export default routes;
